<!-- Spinners -->
<ngx-spinner
  name="primary"
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  [fullScreen]="true"
  type="ball-scale-multiple"
  template="<img src='assets/img/reite_iso_white.png' class='block h-auto w-16 pl-2 animate-ping' />">
</ngx-spinner>
<ngx-spinner
    name="cooler-opening"
    bdColor="rgba(0, 0, 0, 0.8)"
    size="medium"
    color="#fff"
    type="ball-scale-multiple"
    [fullScreen]="false">
    <h2>{{ 'components.default.opening_store' | translate }}</h2>
</ngx-spinner>
<router-outlet></router-outlet>
<!--
  Mounted here rather than inside a shell component: `DefaultComponent` and
  `DefaultUnloggedComponent` are siblings, and `verify-email` / `bind` sit outside both, so this is
  the only host every visitor passes through — including anonymous ones on `catalog/:id`.
-->
<app-cookie-banner></app-cookie-banner>
